import { IGetWordBanksPayload } from 'types'

const urls = {
  session: {
    signIn: () => '/login'
  },
  account: {
    resetPassword: () => '/reset-password',
    resetPasswordRequest: () => '/reset-password',
    register: () => '/register',
    emailVerification: {
      verifyEmail: () => '/email-verification',
      resend: () => '/resend-email-verification'
    },
    registrationCode: {
      checkRegistrationCode: (email: string, code: string) => `/invite?email=${email}&code=${code}`,
      requestRegistrationCode: () => '/invite/request'
    }
  },
  me: {
    avatar: () => '/me/avatar',
    profile: () => '/me',
    data: () => '/me/data',
    acceptTermsOfService: () => '/me/consent',
    deleteAccount: () => '/me/delete',
    listInitiatives: () => '/me/initiatives',
    media: {
      file: () => '/me/media/file',
      link: () => '/me/media/link',
      deleteLink: (index: number) => `/me/media/link/${index}`
    },
    initiatives: (userId: string) => `/me/initiatives-responses/${userId}`
  },
  wordBanks: {
    get: ({ category, userId }: IGetWordBanksPayload) =>
      `/v3/wordbanks?category=${category}${userId ? `&userId=${userId}` : ''}`,
    create: () => '/v3/me/wordbanks'
  },
  algolia: (input: string) => `/wordbanks/algolia-places?input=${input}`,
  settings: {
    changeCredentials: () => '/change-credentials'
  },
  userResponse: {
    update: () => '/v3/me/response',
    get: () => '/v2/me/responses'
  },
  billboard: {
    pdf: (userId: string) => `billboard/${userId}/pdf`,
    json: (userId: string) => `v3/billboard/${userId}/json`
  },
  schools: {
    get: (school?: string) => `/v3/schools?${school ? `school=${school}` : ''}`,
    create: () => 'v2/schools'
  },
  enterprise: {
    loadInitiativeSymbol: (enterpriseId: string, submissionLinkCode: string) =>
      `/${enterpriseId}/initiatives/${submissionLinkCode}/questions-draft`,
    saveInitiativeSubmissionDraft: (enterpriseId: string, initiativeId: number) =>
      `/${enterpriseId}/initiatives/${initiativeId}/questions-draft`,
    submission: () => `/enterprise-submission`,
    loadInitiativeForEdition: (enterpriseId: string, initiativeId: number) =>
      `/${enterpriseId}/initiatives/${initiativeId}`,
    withdrawFromInitiative: (enterpriseId: string, initiativeId: number) =>
      `/${enterpriseId}/initiatives/${initiativeId}`,
    withdrawFromEnterprise: (enterpriseId: string) => `/${enterpriseId}/submissions`
  },
  eventLogger: {
    pageView: () => '/v1/events/page-view'
  },
  enterprisePlaylist: {
    fetch: (enterpriseId: string, playlistCode: string) => `/${enterpriseId}/playlist/${playlistCode}/details`
  }
}

export default urls
